import type { ReactNode } from "react";
import { Text } from "../../primitives";
import { ExposureChart, type ExposureChartProps, ExposureTitle } from "./ExposureChart";

export type ExposureWithTermsProps = ExposureChartProps & {
	terms: ReactNode;
	title?: string;
	breakdownCaption?: string;
};

export const ExposureWithTerms = ({
	terms,
	title = "Exposure & Terms",
	breakdownCaption,
	testId = "exposure",
	...chart
}: ExposureWithTermsProps) => (
	<ExposureChart
		{...chart}
		testId={testId}
		headerClassName={breakdownCaption === undefined ? "gap-1" : "gap-5"}
		header={
			<div className="flex flex-col items-stretch gap-5">
				<ExposureTitle title={title} />
				<div className="min-w-0">{terms}</div>
			</div>
		}
		caption={
			breakdownCaption !== undefined && (
				<Text type="eyebrow" color="tertiary" data-testid={`${testId}-breakdown`}>
					{breakdownCaption}
				</Text>
			)
		}
	/>
);
